import { render, staticRenderFns } from "./OrderInvoice.vue?vue&type=template&id=53ac828a&"
import script from "./OrderInvoice.vue?vue&type=script&lang=js&"
export * from "./OrderInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports